<template>
  <div v-if="xuanfumianbanShow">
    <div v-if="!pupopShow" class="t_model_box">
      <!-- top -->
      <div class="t_top_model">
        <div
          class="t_comp_card"
          :style="{ backgroundImage: 'url(' + topimg + ')' }"
        >
          <div style="font-size: 18px; color: white">{{ topTitle }}</div>
          <div
            style="
              font-size: 14px;
              color: white;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              width: 100%;
            "
          >
            {{ detailAddress }}
          </div>
          <div class="t_comp_card_tab_box">
            <div v-if="dwlx" class="t_comp_card_tab">{{ dwlx }}</div>
            <template v-if="xzList.length > 0">
              <div
                v-for="(item, index) in xzList"
                :key="index"
                class="t_comp_card_tab"
              >
                {{ item }}
              </div>
            </template>
          </div>
        </div>
        <div style="flex-grow: 1; flex-shrink: 1">
          <div class="t_model_title_box">
            <div class="t_model_title">快捷应用</div>
            <!-- <div
                  style="font-size: 13px; display: flex; align-items: center"
                >
                  自定义<img
                    src="@/assets/img/dis7.png"
                    style="height: 14px; margin-left: 5px"
                  />
                </div> -->
          </div>
          <!-- yhtype:1 =>生产 -->
          <div
            v-if="yhtype == '1'"
            style="display: flex; justify-content: space-between"
          >
            <div
              v-if="cur_all_lx.includes('2') || cur_all_lx.includes('3')"
              class="t_kjyy_font"
              @click="$router.push('/Gmsq')"
            >
              <img src="@/assets/img/dis3.png">
              <div>购买证办理</div>
            </div>
            <div
              class="t_kjyy_font"
              @click="$router.push('/Yssq')"
            >
              <img src="@/assets/img/dis4.png">
              <div>运输证办理</div>
            </div>
            <div
              class="t_kjyy_font"
              @click="$router.push('/Scrk')"
            >
              <img src="@/assets/img/dis1.png">
              <div>生产入库</div>
            </div>
            <div
              class="t_kjyy_font"
              @click="$router.push('/Xsck')"
            >
              <img src="@/assets/img/dis2.png">
              <div>销售出库</div>
            </div>
            <div
              class="t_kjyy_font"
              @click="$router.push('/Wldw')"
            >
              <img src="@/assets/img/dis5.png">
              <div>往来单位</div>
            </div>
            <div
              v-if="!!tsomsPath"
              class="t_kjyy_font"
              @click="gotoddxt"
            >
              <img src="@/assets/img/dis5.png">
              <div>RFID订单</div>
            </div>
          </div>
          <!-- yhtype:2 =>使用 -->
          <div
            v-if="yhtype == '2'"
            style="display: flex; justify-content: space-between"
          >
            <div
              class="t_kjyy_font"
              @click="$router.push('/Gmsq')"
            >
              <img src="@/assets/img/dis3.png">
              <div>购买证办理</div>
            </div>
            <div
              class="t_kjyy_font"
              @click="$router.push('/Yssq')"
            >
              <img src="@/assets/img/dis4.png">
              <div>运输证办理</div>
            </div>
            <div
              class="t_kjyy_font"
              @click="$router.push('/Tzgmrk')"
            >
              <img src="@/assets/img/dis1.png">
              <div>购买入库</div>
            </div>
            <div
              class="t_kjyy_font"
              @click="$router.push('/Syck')"
            >
              <img src="@/assets/img/dis2.png">
              <div>使用出库</div>
            </div>
            <div
              class="t_kjyy_font"
              @click="$router.push('/Wldw')"
            >
              <img src="@/assets/img/dis5.png">
              <div>往来单位</div>
            </div>
            <div
              v-if="!!tsomsPath"
              class="t_kjyy_font"
              @click="gotoddxt"
            >
              <img src="@/assets/img/dis5.png">
              <div>RFID订单</div>
            </div>
          </div>
          <!-- yhtype:3 =>经营 -->
          <div
            v-if="yhtype == '3'"
            style="display: flex; justify-content: space-between"
          >
            <div
              class="t_kjyy_font"
              @click="$router.push('/Gmsq')"
            >
              <img src="@/assets/img/dis3.png">
              <div>购买证办理</div>
            </div>
            <div
              class="t_kjyy_font"
              @click="$router.push('/Yssq')"
            >
              <img src="@/assets/img/dis4.png">
              <div>运输证办理</div>
            </div>
            <div
              class="t_kjyy_font"
              @click="$router.push('/Tzgmrk')"
            >
              <img src="@/assets/img/dis1.png">
              <div>购买入库</div>
            </div>
            <div
              class="t_kjyy_font"
              @click="$router.push('/Xsck')"
            >
              <img src="@/assets/img/dis2.png">
              <div>销售出库</div>
            </div>
            <div
              class="t_kjyy_font"
              @click="$router.push('/Wldw')"
            >
              <img src="@/assets/img/dis5.png">
              <div>往来单位</div>
            </div>
            <div
              v-if="!!tsomsPath"
              class="t_kjyy_font"
              @click="gotoddxt"
            >
              <img src="@/assets/img/dis5.png">
              <div>RFID订单</div>
            </div>
          </div>
          <!-- yhtype:4 =>运输 -->
          <div
            v-if="yhtype == '4'"
            style="display: flex; justify-content: space-between"
          >
            <div
              class="t_kjyy_font"
              @click="$router.push('/Yssq')"
            >
              <img src="@/assets/img/dis4.png">
              <div>运输证办理</div>
            </div>
            <div
              class="t_kjyy_font"
              @click="$router.push('/Ysbb')"
            >
              <img src="@/assets/img/dis2.png">
              <div>运输报备</div>
            </div>
            <div
              class="t_kjyy_font"
              @click="$router.push('/Wldw')"
            >
              <img src="@/assets/img/dis5.png">
              <div>往来单位</div>
            </div>
            <div
              v-if="!!tsomsPath"
              class="t_kjyy_font"
              @click="gotoddxt"
            >
              <img src="@/assets/img/dis5.png">
              <div>RFID订单</div>
            </div>
          </div>
          <!-- yhtype:6 =>运输 -->
          <div
            v-if="yhtype == '6'"
            style="display: flex;"
          >
            <div
              class="t_kjyy_font"
              style=" margin-right:40px"
              @click="$router.push('/Yssq')"
            >
              <img src="@/assets/img/dis4.png">
              <div>运输证办理</div>
            </div>
            <div
              class="t_kjyy_font"
              @click="$router.push('/Wldw')"
            >
              <img src="@/assets/img/dis5.png">
              <div>往来单位</div>
            </div>
            <div
              v-if="!!tsomsPath"
              class="t_kjyy_font"
              @click="gotoddxt"
            >
              <img src="@/assets/img/dis5.png">
              <div>RFID订单</div>
            </div>
          </div>
          <div v-if="false">
            <div style="display: flex; justify-content: space-between">
              <div
                v-if="yhtype !== '1'"
                class="t_kjyy_font"
                @click="$router.push('/Gmsq')"
              >
                <img src="@/assets/img/dis3.png">
                <div>购买证办理</div>
              </div>
              <div
                class="t_kjyy_font"
                @click="$router.push('/Yssq')"
              >
                <img src="@/assets/img/dis4.png">
                <div>运输证办理</div>
              </div>
              <!-- 入库start -->
              <div
                v-if="yhtype == 1"
                class="t_kjyy_font"
                @click="$router.push('/Scrk')"
              >
                <img src="@/assets/img/dis1.png">
                <div>生产入库</div>
              </div>
              <div
                v-if="yhtype == 2 || yhtype == 3"
                class="t_kjyy_font"
                @click="$router.push('/Tzgmrk')"
              >
                <img src="@/assets/img/dis1.png">
                <div>购买入库</div>
              </div>
              <div
                v-if="yhtype == 5"
                class="t_kjyy_font"
                @click="$router.push('/Ccrk')"
              >
                <img src="@/assets/img/dis1.png">
                <div>仓储入库</div>
              </div>
              <!-- 入库end -->
              <!-- 出库start -->

              <div
                v-if="yhtype == 1 || yhtype == 3"
                class="t_kjyy_font"
                @click="$router.push('/Xsck')"
              >
                <img src="@/assets/img/dis2.png">
                <div>销售出库</div>
              </div>
              <div
                v-if="yhtype == 2"
                class="t_kjyy_font"
                @click="$router.push('/Syck')"
              >
                <img src="@/assets/img/dis2.png">
                <div>使用出库</div>
              </div>
              <div
                v-if="yhtype == 5"
                class="t_kjyy_font"
                @click="$router.push('/Ccck')"
              >
                <img src="@/assets/img/dis2.png">
                <div>仓储出库</div>
              </div>
              <!-- 出库end -->
              <!-- 运输报备start -->
              <div
                v-if="yhtype == 4"
                class="t_kjyy_font"
                @click="$router.push('/Ysbb')"
              >
                <img src="@/assets/img/dis2.png">
                <div>运输报备</div>
              </div>
              <!-- 运输报备end -->
              <div
                class="t_kjyy_font"
                @click="$router.push('/Wldw')"
              >
                <img src="@/assets/img/dis5.png">
                <div>往来单位</div>
              </div>
              <!-- <div style="font-size: 14px; font-weight: bold; text-align: center">
              <img
                src="@/assets/img/dis6.png"
                style="width: 3.5vw; margin-bottom: 1vw"
              />
              <div>业务流程指南</div>
            </div> -->
            </div>
          </div>
        </div>
      </div>
      <!-- 我的消息 我的代办 -->
      <div class="t_center_model">
        <!-- 我的消息 -->
        <div class="t_msg_model" style="position: relative">
          <div class="t_line_blue" style="bottom: 0px" />
          <div class="t_model_title_box">
            <div class="t_model_title">
              <span
                style="
                  width: 6px;
                  height: 24px;
                  display: inline-block;
                  background-color: #648aff;
                  margin-right: 15px;
                "
              />
              我的消息
            </div>
            <div style="font-size: 13px; display: flex; align-items: center">
              <img
                src="@/assets/img/ref.png"
                :class="{'rotate360':showXs}"
                style="height: 18px; margin-left: 5px; cursor: pointer"
                @click="hallWdxx"
              >
            </div>
          </div>
          <div class="t_mymsg">
            <div
              v-for="(item, k) in wdxxData"
              :key="k"
              class="t_mymsg_item"
              style="padding: 1.25vw 1.5vw"
              @click="hwodexiaoxiXq(item)"
            >
              <div class="t_mymsg_left">
                <div
                  v-if="item.view"
                  style="width: 12px; border-radius: 50%; margin-right: 7px"
                >
                  <img src="@/assets/img/duigou.png" alt="" width="100%">
                </div>
                <div
                  v-else
                  style="
                    width: 7px;
                    height: 7px;
                    background-color: red;
                    border-radius: 50%;
                    margin-right: 6px;
                    margin-left: 6px;
                  "
                />
                <div
                  style="
                    font-size: 14px;
                    width: 90%;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  "
                >
                  {{ item.title }}
                </div>
              </div>
              <div style="font-size: 15px">{{ item.publishTimeByDate }}</div>
            </div>
          </div>
        </div>
        <!-- 我的代办 -->
        <div class="t_todo_model" style="position: relative">
          <div class="t_line_blue" style="bottom: 94px" />
          <div class="t_model_title_box">
            <div class="t_model_title">
              <span
                style="
                  width: 6px;
                  height: 24px;
                  display: inline-block;
                  background-color: #ffae3b;
                  margin-right: 15px;
                "
              />
              我的待办
            </div>
            <div style="font-size: 13px; display: flex; align-items: center">
              <img
                :class="{'rotate360':showDb}"
                src="@/assets/img/ref.png"
                style="height: 18px; margin-left: 5px; cursor: pointer;"
                @click="getwddb"
              >
            </div>
          </div>
          <div class="t_mymsg">
            <div
              v-for="(item, index) in dblist"
              :key="index + item"
              class="t_mymsg_item"
            >
              <div class="t_mymsg_left">
                <div
                  style="
                    font-size: 14px;
                    width: 90%;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  "
                >
                  <div
                    :title="item.tsxx"
                    style="cursor: pointer; margin-top: 4px"
                  >
                    {{ item.tsxx }}
                  </div>
                </div>
              </div>
              <div class="t_todo_right">
                <div
                  class="t_deal_btn"
                  @click="operation(item)"
                >
                  处理
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 待审已审 -->
      <div class="t_bottom_model">
        <div class="t_model_title_box">
          <div class="t_model_title">
            <span
              style="
                width: 6px;
                height: 24px;
                display: inline-block;
                background-color: #54d3db;
                margin-right: 15px;
              "
            />
            业务申请
          </div>
        </div>
        <div class="t_check">
          <div class="t_word">
            <!-- <div class="t_model_second_title">
                  <img
                    src="@/assets/img/check1.png"
                    style="width: 17px; margin-right: 10px"
                    alt=""
                  />
                  待审业务
                </div> -->
            <div style="display: flex; flex-direction: column; height: 100%">
              <div class="t_check_table_head">
                <div style="width: 20%; text-align: center">业务类型</div>
                <div style="width: 45%; text-align: center">申请内容</div>
                <div style="width: 20%; text-align: center">申请时间</div>
                <div style="width: 15%; text-align: center">业务状态</div>
              </div>
              <div class="t_check_table_body">
                <div
                  v-for="(item, index) in ywlxlist"
                  :key="index"
                  class="t_check_table_item"
                >
                  <div
                    style="
                      width: 20%;
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                    "
                  >
                    {{ item.ywlxLabel }}
                  </div>
                  <div
                    style="
                      width: 45%;
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                    "
                  >
                    <div
                      :title="item.sqgjnr"
                      style="cursor: pointer; margin-top: 4px"
                    >
                      {{ item.sqgjnr }}
                    </div>
                  </div>
                  <div style="width: 20%; text-align: center">
                    {{ item.clsj }}
                  </div>
                  <div style="width: 15%; text-align: center">
                    <span class="t_check_type1">{{ item.sftyLabel }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="t_model_box">
      <xxhd-document
        v-if="pupopShow"
        ref="xxhdDocument"
        :title="title"
        :fbsj="fbsj"
        :fbjg="fbjg"
        :content="content"
        :fj-url="fjUrl"
      />
    </div>
    <!-- 信息填写完整 -->
    <div v-if="bqwindow" class="t_tips_box">
      <i
        style="
          position: absolute;
          top: 8px;
          right: 8px;
          cursor: pointer;
          color: #4170ff;
        "
        class="el-icon-close"
        @click="bqwindow = !bqwindow"
      />
      <div
        style="
          text-align: center;
          margin-left: auto;
          margin-right: auto;
          width: 400px;
          line-height: 30px;
        "
      >
        您的密码太过简单，请及时修改为复杂密码
      </div>

      <div
        style="
          display: flex;
          justify-content: space-between;
          width: 300px;
          margin-left: auto;
          margin-right: auto;
          margin-top: 30px;
        "
      >
        <span
          style="
            font-size: 14px;
            cursor: pointer;
            color: #737373;
            border: 1px solid #b8b8b8;
            border-radius: 3px;
            padding: 5px 20px;
            margin: 0 auto;
          "
          @click="switchange(1)"
        >修改密码</span>
      </div>
    </div>

    <qqCS :zxfw-url="zxfwUrl" :kfdh="kfdh"/>
    <!-- 悬浮按钮 -->
    <div v-if="xuanfuBtnShow" class="xuanfuBtn">
      <div class="xuanfuBtn_tx" />
      <div class="anBtn" @click="hxuanfuBtn('czsc')">
        操作手册
        <span />
      </div>
      <div class="anBtn" @click="hxuanfuBtn('lyb')">
        留言板
        <span />
      </div>

      <div class="anBtn" @click="hxuanfuBtn('cywt')">
        常见问题
        <span />
      </div>

      <i
        class="el-icon-arrow-right"
        @click="xuanfuBtnShow = !xuanfuBtnShow"
      />
    </div>
    <div
      v-else
      class="xuanfuBtn_zhankai"
      @click="xuanfuBtnShow = !xuanfuBtnShow"
    >
      <i class="el-icon-arrow-left" />
    </div>
  </div>
  <div v-else class="xuanfumianban">
    <div v-if="xuanfuType == 'cywt'" class="xuanfumianban_cywt">
<!--      <img
        class="jumpPng"
        src="@/assets/img/1v1.png"
        @click="jump"
      >-->
      <cywt />
    </div>
    <div v-if="xuanfuType == 'lyb'" class="xuanfumianban_lyb">
<!--      <img
        class="jumpPng"
        src="@/assets/img/1v1.png"
        @click="jump"
      >-->
      <lyb />
    </div>

    <!-- 悬浮按钮 -->
    <div v-if="xuanfuBtnShow" class="xuanfuBtn">
      <div class="xuanfuBtn_tx" />
      <div class="anBtn" @click="hxuanfuBtn('czsc')">
        操作手册
        <span />
      </div>
      <div class="anBtn" @click="hxuanfuBtn('lyb')">
        留言板
        <span />
      </div>

      <div class="anBtn" @click="hxuanfuBtn('cywt')">
        常见问题
        <span />
      </div>

      <i
        class="el-icon-arrow-right"
        @click="xuanfuBtnShow = !xuanfuBtnShow"
      />
    </div>
    <div
      v-else
      class="xuanfuBtn_zhankai"
      @click="xuanfuBtnShow = !xuanfuBtnShow"
    >
      <i class="el-icon-arrow-left" />
    </div>
  </div>
</template>

<script>
// 留言板
import lyb from './lyb.vue'
// 常见问题
import cywt from './cywt.vue'

// 我的消息
import XxhdDocument from '@/components/xxhd/xxhdDocument.vue'
import { hallckmb, getKfdh } from '@/assets/js/wangshuai.js'
// 获取接口地址
import { getToken } from '@/assets/js/common.js'
import { hallWdxx } from '@/assets/js/wangshuai.js'
import { getHomeDetail, validPassword } from '@/assets/js/home.js'
import qqCS from '@/components/qqCS'
import { getLoginDwZt, getwddb, getywsq } from '@/assets/js/dashboard'
export default {
  name: 'Dashboard',
  components: { XxhdDocument, cywt, lyb, qqCS },
  data() {
    return {
      cur_all_lx: '',
      xuanfuBtnShow: true, // 悬浮按钮
      xuanfumianbanShow: true,
      xuanfuType: '',
      // 业务类型
      ywlxlist: [],
      showDb: false,
      showXs: false,
      // 补全
      bqwindow: false,
      zxfwUrl: '',
      kfdh: '', //客服电话
      // switch
      // switchvalue:false,
      dwlx: '', // 单位性质
      xzList: [],
      dblist: [], // 我的待办
      detailAddress: '', // 具体地址
      topTitle: '',
      topimg: require('@/assets/img/compimg.png'),
      zctype: 1, // 0未申请 1通过 2未通过 3审核中
      yhtype: null, // 用户种类
      wdxxData: [],
      pupopShow: false,
      title: '',
      fbsj: '',
      fbjg: '',
      content: '',
      fjUrl: '',
      // 订单系统地址
      tsomsPath: process.env.VUE_APP_TSOMS_PATH
    }
  },
  created() {
    //
    // this.getswitch()
  },
  mounted() {
    validPassword().then((res) => {
      this.bqwindow = !res.data.data
    })
    this.getKfrx() //获取客服电话
    this.hallWdxx()
    this.getHomeContent()
    // 我的代办
    this.getwddb()
    // 业务申请
    this.getywsq()
  },
  methods: {
    // 获取客服热线
    getKfrx() {
      getKfdh().then((res) => {
        this.kfdh = res.data.data
      })
    },
    jump() {
      window.open('http://gx.gayzd.com/zixun?ent=' + this.topTitle)
    },
    gotoddxt() {
      // 跳转订单系统
      const token = getToken().split(' ')
      if (token && token.length == 2) {
        const backpath = location.href
        location.href = `${this.tsomsPath}/tokenlogin?token=${token[1]}&logout=${encodeURIComponent(backpath)}`
      }
    },
    // 悬浮按钮
    hxuanfuBtn(val) {
      if (val == 'czsc') {
        const link = document.createElement('a')
        link.href = process.env.VUE_APP_PUBLIC_PORT + '/operationManual.pdf'
        link.download = '易制毒化学品管理服务平台操作手册'
        link.click()
      } else {
        this.xuanfumianbanShow = false
        this.xuanfuType = val
      }

      // if (val == "cywt") {
      //   this.xuanfumianbanShow = false;
      //   this.xuanfuType = val;
      // } else if (val == "lyb") {
      //   this.xuanfumianbanShow = false;
      //   this.xuanfuType = val;
      // }
    },
    // 连接责任书
    hzrsLj() {
      this.$router.push('/Qyxxbg')
    },
    // 是否不在通知
    switchange(type) {
      // this.$cookies.set('isTz', false)
      this.bqwindow = false
      this.$router.push('/PersonalCenter')
      // this.$router.push({
      //   name: "Gmrk",
      //   params: { xkzBh: row.xkzbh },
      // });
    },
    getswitch() {
      if (this.$cookies.get('isTz') == 'false') {
        this.bqwindow = false
      } else {
        this.bqwindow = true
      }
      // this.bqwindow=this.$cookies.get("isTz");
    },
    operation(item) {
      /* console.log(item);
      return; */
      switch (item.ywlxbm) {
        case '1':
          // 单位资质到期提醒
          this.$router.push({
            name: 'Qyxxbg',
            params: { zjlx: item.zjlx, id: item.dwid }
          })
          break
        case '2':
          // 购买许可证(备案)未使用提醒
          this.$router.push({
            name: 'Gmrk',
            params: { xkzBh: item.ywbh }
          })
          break
        case '3':
          // 运输许可证(备案)未使用提醒
          this.$router.push({
            name: 'Ysbb',
            params: { xkzBh: item.ywbh }
          })
          break
        case '4':
          // 证件核销
          if (item.xkzlxbh == '1') {
            // 购买证
            this.$router.push({ name: 'Gmsq', params: { id: item.ywid }})
          } else if (item.xkzlxbh == '2') {
            // 运输证
            this.$router.push({ name: 'Yssq', params: { id: item.ywid }})
          }
          break
        case '5':
          // 责任书到期提醒
          this.$router.push({ name: `Zrsqd` })
          break
      }
    },
    hwodexiaoxiXq(data) {
      hallckmb(data.noticeId).then((res) => {
        if (res.status == 200) {
          this.pupopShow = true
          this.title = res.data.data.title
          this.fbsj = res.data.data.publishTime
          this.fbjg = res.data.data.deptName
          this.content = res.data.data.content
          this.fjUrl = res.data.data.fj
        }
      })
    },
    // 我的代办
    getwddb() {
      if (this.showDb) {
        return
      }
      this.showDb = true
      getwddb({
        ywlxbm: ''
      }).then((e) => {
        this.dblist = e.data.data
        setTimeout(() => {
          this.showDb = false
        }, 500)
      }).catch(err => {
        console.log('err', err)
        setTimeout(() => {
          this.showDb = false
        }, 500)
      })
    },
    // 业务申请
    getywsq() {
      getywsq().then((e) => {
        this.ywlxlist = e.data.data
      })
    },
    // 获取首页信息@y1215
    getHomeContent() {
      getHomeDetail().then((res) => {
        if (res.status == 200) {
          // 赋值
          this.topTitle = res.data.data.dwmc
          this.detailAddress =
            res.data.data.provinceLabel +
            '/' +
            res.data.data.cityLabel +
            '/' +
            res.data.data.countyLabel
          this.xzList = res.data.data.ywlxLabel.split()
          this.dwlx = res.data.data.dwlxLabel
          this.yhtype = res.data.data.yhtype
          this.cur_all_lx = res.data.data.ywlx
          this.zxfwUrl = res.data.data.sjZxfwUrl
          this.$bus.$emit('getSjLxdh', res.data.data.sjLxdh)
        }
      })
    },
    // 判断单位审核状态
    checktype() {
      getLoginDwZt().then((e) => {
        //  1 审批通过
        //  0 正在审批中
        //  3 审批未通过
        //  5 未入网
        if (e.data.data.zt == 5) {
          // 未申请
          this.$router.push('/Rwsq')
        } else if (e.data.data.zt == 1) {
          // 申请通过
        } else if (e.data.data.zt == 3) {
          // 未通过
          this.$router.push('/Spfail')
        } else if (e.data.data.zt == 0) {
          // 审核中
          this.$router.push('/Spload')
        }
      })
    },

    hallWdxx() {
      if (this.showXs) {
        return
      }
      this.showXs = true
      hallWdxx().then((e) => {
        this.wdxxData = e.data.data
        setTimeout(() => {
          this.showXs = false
        }, 500)
      }).catch(err => {
        console.log('err', err)
        setTimeout(() => {
          this.showXs = false
        }, 500)
      })
    }
  }
}
</script>
<style scoped lang="less">
.t_top_model {
  background-color: white;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.11);
}
.t_top_model {
  /* height: 242px; */
  display: flex;
  padding: 1.5vw 3vw 1.5vw 2vw;
}
.t_center_model {
  margin-top: 1.5vw;
  margin-bottom: 1.5vw;
  display: flex;
  justify-content: space-between;
}
.t_model_box {
  padding: 3vw;
}
.t_model_title_box {
  display: flex;
  justify-content: space-between;
  margin-bottom: 1vw;
  margin-top: 0.5vw;
}
.t_model_title {
  font-size: 18px;
  font-weight: bold;
  display: flex;
  align-items: center;
}
.t_model_second_title {
  font-size: 16px;
  font-weight: bold;
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}
.t_comp_card {
  width: 25vw;
  margin-right: 4vw;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.11);
  min-height: 9.7vw;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 1.5vw 2vw;
}
.t_comp_card_tab_box {
  display: flex;
  flex-wrap: wrap;
}
.t_comp_card_tab {
  border: 1px solid #4dcfff;
  color: white;
  font-size: 13px;
  padding: 0.3vw;
  border-radius: 3px;
  margin-right: 1vw;
  margin-top: 5px;
}
.t_mymsg {
  background-color: white;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.11);
  padding: 0.8vw 0;
  height: 286px;
  overflow-y: auto;
}
.t_line_blue {
  width: 6px;
  height: 120px;
  background-color: #648aff;
  position: absolute;
  left: 0;
}
.t_mymsg_item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.8vw 1.5vw;
}
.t_mymsg_item:hover {
  background-color: #f2f5ff;
}
.t_mymsg_item:last-child {
  margin-bottom: 0;
}

.t_mymsg_left {
  display: flex;
  align-items: center;
  flex-grow: 1;
  width: 0;
}
.t_msg_model,
.t_todo_model {
  width: 48%;
}
.t_deal_btn {
  font-size: 13px;
  background-color: #54d3db;
  width: 64px;
  line-height: 32px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.13);
  text-align: center;
  color: white;
  margin-left: 2vw;
}
.t_todo_right {
  display: flex;
  align-items: center;
}
.t_check {
  height: 310px;
  padding: 1.5vw 1vw;
  background-color: white;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.11);
  display: flex;
  justify-content: space-between;
}
.t_word {
  width: 100%;
  height: 100%;
  /* border: 1px solid red; */
}
.t_check_table_head {
  background-color: #dee6ff;
  display: flex;
  padding: 0.6vw 1.6vw;
  font-size: 14px;
}
.t_check_table_item {
  display: flex;
  font-size: 14px;
  align-items: center;
  padding: 0.6vw 1.6vw;
}
.t_check_table_item:hover {
  background-color: #f2f5ff;
}
.t_check_table_item:last-child {
  margin-bottom: 0;
}
.t_check_table_body {
  /* height: 203px; */
  border: 1px solid #7093fe;
  border-top: none;
  overflow: auto;
}
.rotate360 {
  animation: rotate360 .5s ease-out 0s;
}
@keyframes rotate360 {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.t_check_type1 {
  font-size: 13px;
  background-color: #fff0de;
  width: 64px;
  line-height: 32px;
  text-align: center;
  display: inline-block;
}
.t_kjyy_font {
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  cursor: pointer;
}
.t_kjyy_font img {
  width: 3.5vw;
  margin-bottom: 1vw;
}
.t_tips_box {
  position: fixed;
  top: 20px;
  width: 550px;
  left: 50%;
  margin-left: -275px;
  background-color: #f1f8fe;
  font-size: 15px;
  padding: 30px 20px;
  border-radius: 5px;
}
.jumpPng {
  width: 150px;
  height: 110px;
  position: fixed;
  top: 30%;
  right: 10px;
  z-index: 999999999;
  padding-top: 15px;
}
.xuanfuBtn {
  width: 130px;
  height: 180px;
  background-color: white;
  position: fixed;
  top: 80%;
  right: 10px;
  z-index: 999999999;
  margin-top: -100px;
  padding-top: 15px;

  box-sizing: border-box;
  border-radius: 4px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.11);

  .anBtn {
    position: relative;
    width: 90%;
    height: 40px;
    text-align: center;
    line-height: 40px;
    font-size: 14px;
    margin-top: 10px;
    font-weight: 700;
    z-index: 99;
    &:hover {
      color: #007acc;
      cursor: pointer;
    }

    span {
      position: absolute;
      bottom: 10px;
      left: 50%;
      width: 60%;
      height: 8px;
      margin-left: -30%;
      background-color: #f9e0a2;
      border-radius: 4px;
      z-index: -1;
    }
  }

  .el-icon-arrow-right {
    font-size: 16px;
    width: 10%;
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    text-align: center;
    line-height: 180px;

    &:hover {
      background-color: rgba(0, 0, 0, 0.11);
      cursor: pointer;
    }
  }

  .xuanfuBtn_tx {
    width: 40px;
    height: 40px;
    background-image: url("../assets/img/sftk/tubiao.png");
    position: absolute;
    top: -40px;
    left: 50%;
    margin-left: -20px;
  }
}
.xuanfuBtn_zhankai {
  z-index: 999999999;
  position: fixed;
  top: 80%;
  right: 10px;
  width: 13px;
  height: 180px;
  text-align: center;
  line-height: 180px;
  font-size: 16px;
  margin-top: -100px;
  background-color: white;
  box-sizing: border-box;
  border-radius: 4px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.11);
  &:hover {
    background-color: rgba(0, 0, 0, 0.11);
    cursor: pointer;
  }
}
.xuanfumianban {
  width: 100%;
  height: 100%;
  background-color: #eef1f9;

  .xuanfumianban_cywt,
  .xuanfumianban_lyb {
    width: 80%;
    margin: 15px auto 0;
    background-color: white;
  }
}
</style>
